import { useEffect, useState, useContext, useRef, use } from "react";
import { createBrowserRouter, useNavigate, useParams, useSearchParams } from "react-router";
import { renderToStaticMarkup } from 'react-dom/server';

import { AppContext } from '../../context.js';
import { Minus, CheckLarge, Print } from "../../files/icons/index.js";
import Loading from "../components/loading.js";
import axios from "axios";
import Helmet from "../components/helmet.js";

import { DatetimeToDate, DateToTimestamp, DateToFormat, calculateAge } from "../../utils/datetime.js";

function Export() {
  const context = useContext(AppContext);

  let { id } = useParams();
  
  const [loading, setLoading] = useState(true);

  // Data
  const [patient, setPatient] = useState(null);
  const [projects, setProjects] = useState([]);
  const [plans, setPlans] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [assessments, setAssessments] = useState([]);
  
  const [settings, setSettings] = useState(null);

  // Options
  const [exportPlans, setExportPlans] = useState([]);
  const [exportProjects, setExportProjects] = useState([]);
  const [exportAssessments, setExportAssessments] = useState([]);
  
  useEffect(() => {
    let u = context.addSpiner();
    axios.all([
      axios.post('/api/admin/patients', {
        filter: {
          id: [id],
        }
      }),
      axios.post('/api/admin/plans', {
        filter: {
          patientID: [id],
          //closedAt: null,
        }
      }),
      axios.post('/api/admin/projects', {
        filter: {
          patientID: [id],
          archived: null, // Get both archived and not projects
        }
      }),
      axios.post('/api/admin/appointments', {
        filter: {
          patientID: [id],
        }
      }),
      axios.post('/api/admin/assessments', {
        filter: {
          patientID: [id],
        }
      }),
      axios.get('/api/admin/settings', {
      }),
    ]).then(axios.spread((patient, plans, projects, appointments, assessments, settings) => {
      // Set data
      setPatient(patient.data.patients[0]);
      setPlans(plans.data.plans);
      setProjects(projects.data.projects);
      setAppointments(appointments.data.appointments);
      setAssessments(assessments.data.assessments);
      setSettings(settings.data);

      // Set default
      if (plans.data.plans.length > 0) {
        setExportPlans([plans.data.plans.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0].id]);
      }

      setLoading(false);
    })).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, []);

  // Menu
  function renderPlans() {
    
  }

  function selectPlan(planID) {
    let newExportPlans = [...exportPlans];
    let index = newExportPlans.findIndex((i) => i === planID);
    if (index !== -1) {
      // Remove the plan from the export
      newExportPlans.splice(index, 1);
    } else {
      // Add the plan to the export
      newExportPlans.push(planID);
    }
    setExportPlans(newExportPlans);
  }

  function selectProject(projectID) {
    let newExportProjects = [...exportProjects];
    let index = newExportProjects.findIndex((i) => i === projectID);
    if (index !== -1) {
      // Remove the project from the export
      newExportProjects.splice(index, 1);
    } else {
      // Add the project to the export
      newExportProjects.push(projectID);
    }
    setExportProjects(newExportProjects);
  }

  function selectAssessment(assessmentID) {
    let newExportAssessments = [...exportAssessments];
    let index = newExportAssessments.findIndex((i) => i === assessmentID);
    if (index !== -1) {
      // Remove the assessment from the export
      newExportAssessments.splice(index, 1);
    } else {
      // Add the assessment to the export
      newExportAssessments.push(assessmentID);
    }
    setExportAssessments(newExportAssessments);
  }

  // Pages
  function renderPages() {
    let content = [];

    // Company header
    content.push(...renderCompanyHeader());

    // Patient
    content.push(...renderPatient());

    // Plans
    const selectedPlans = plans.filter((plan) => exportPlans.includes(plan.id));
    selectedPlans.forEach((plan) => {
      content.push(...renderPlan(plan));
    });

    // Projects
    const selectedProjects = projects.filter((project) => exportProjects.includes(project.id));
    selectedProjects.forEach((project) => {
      content.push(...renderProject(project));
    });

    // Assessments
    const selectedAssessments = assessments.filter((assessment) => exportAssessments.includes(assessment.id));
    selectedAssessments.forEach((assessment) => {
      content.push(...renderAssessment(assessment));
    });

    // Plans

    // switch (scope) {
    //   case 'assessment':

    //     // Render title
    //     content.push({
    //       content: renderH1(assessment.title),
    //       height: 36,
    //     });

    //     content.push({
    //       content: renderSpace(5),
    //       height: 5,
    //     });

    //     content.push({
    //       content: renderHR(),
    //       height: 2,
    //     });

    //     content.push({
    //       content: renderSpace(5),
    //       height: 5,
    //     });

    //     // Render assessment details
    //     content.push({
    //       content: <div className="d-flex justify-content-between align-items-top">
    //         <div className="w-50">
    //           <div className="typo-strong-150">Assigned to:</div>
    //           <div className="typo-normal-175">{assessment.userName ? assessment.userName : "Unassigned"}</div>
    //         </div>
    //         <div className="w-25">
    //           <div className="typo-strong-150">Created at:</div>
    //           <div className="typo-normal-175">{assessment.createdAt ? DateToFormat(DatetimeToDate(assessment.createdAt), context.dateFormat) : ""}</div>
    //         </div>
    //         <div className="w-25">
    //           <div className="typo-strong-150">Closed at:</div>
    //           <div className="typo-normal-175">{assessment.closedAt ? DateToFormat(DatetimeToDate(assessment.closedAt), context.dateFormat) : ""}</div>
    //         </div>
    //       </div>,
    //       height: 44,
    //     });

    //     content.push({
    //       content: renderSpace(5),
    //       height: 5,
    //     });

    //     content.push({
    //       content: renderHR(),
    //       height: 2,
    //     });

    //     content.push({
    //       content: renderSpace(5),
    //       height: 5,
    //     });

    //     // Render scores
    //     if (exportAssessmentScores) {
    //       if (assessment.scores && assessment.scores.length > 0) {
    //         let scores = assessment.scores.length;
    //         if (scores > 4) {
    //           scores = 4;
    //         }

    //         let scoresContent = (
    //           <div className="d-flex justify-content-start align-items-top">
    //             {assessment.scores.slice(0, scores).map((score, index) => (
    //               <div key={index} className="w-25">
    //                 <div className="typo-strong-150">{score.title}</div>
    //                 <div className="typo-normal-175">{score.score}</div>
    //               </div>
    //             ))}
    //           </div>
    //         );

    //         content.push({
    //           content: scoresContent,
    //           height: 44,
    //         });

    //         content.push({
    //           content: renderHR(),
    //           height: 2,
    //         });

    //         content.push({
    //           content: renderSpace(10),
    //           height: 10,
    //         });
    //       }
    //     }

    //     // Render questions
    //     assessment.questions.forEach((question, index) => {
    //       content.push(calculateHeight(
    //         <div className="typo-strong-175">{question.title}</div>
    //       ));

    //       if (question.answerValue) {
    //         let answer;
    //         switch (question.answerType) {
    //           case 'text':
    //             answer = question.answerValue;
    //             break;
    //           case 'date':
    //             answer = DateToFormat(DatetimeToDate(question.answerValue), context.dateFormat);
    //             break;
    //           case 'options':
    //           case 'optionsColumn':
    //             answer = question.answerOptions[question.answerValue] || "n/a";
    //             break;
    //           default:
    //             answer = question.answerValue;
    //         }

    //         content.push(calculateHeight(
    //           <div className="typo-normal-175">{answer}</div>
    //         ));
    //       } else {
    //         content.push(calculateHeight(
    //           <div className="typo-normal-175">n/a</div>
    //         ));
    //       }

    //       content.push({
    //         content: renderSpace(5),
    //         height: 5,
    //       });
    //     });

    //     break;
    //   case 'patient':
    //     break;
    //   case 'project':
    //     content.push({
    //       content: <div className="d-flex justify-content-between align-items-top">
    //         <div className="w-50">
    //           <div className="typo-strong-150">Assigned to:</div>
    //           <div className="typo-normal-175">{project.userName ? project.userName : "Unassigned"}</div>
    //         </div>
    //         <div className="w-25">
    //           <div className="typo-strong-150">Created at:</div>
    //           <div className="typo-normal-175">{project.createdAt ? DateToFormat(DatetimeToDate(project.createdAt), context.dateFormat) : ""}</div>
    //         </div>
    //         <div className="w-25">
    //           <div className="typo-strong-150">Closed at:</div>
    //           <div className="typo-normal-175">{project.closedAt ? DateToFormat(DatetimeToDate(project.closedAt), context.dateFormat) : ""}</div>
    //         </div>
    //       </div>,
    //       height: 44,
    //     });

    //     content.push({
    //       content: renderSpace(30),
    //       height: 30,
    //     });

    //     // Add patient demographic

    //     // Add care plan
    //     if (exportCarePlan.length > 0 && plan?.sections) {
    //       content.push({
    //         content: renderH1("Care Plan"),
    //         height: 36,
    //       });

    //       content.push({
    //         content: renderHR(),
    //         height: 2,
    //       });

    //       plan.sections.forEach((section) => {
    //         // Only include sections that are selected for export
    //         if (!exportCarePlan.includes(section.id)) {
    //           return;
    //         }

    //         content.push({
    //           content: <div className="typo-strong-200">{section.title}</div>,
    //           height: 20,
    //         });

    //         if ((section.description === null || section.description === undefined || section.description === '') && (!section.actions || section.actions.length === 0)) {
    //           content.push({
    //               content: renderSpace(20),
    //               height: 20,
    //             });
    //         } else {
    //           content.push(calculateHeight(
    //             <div className="typo-normal-150" dangerouslySetInnerHTML={{__html: section.description}} />
    //           ));

    //           section.actions.forEach((action) => {
    //             content.push({
    //               content: (
    //                 <div className="d-flex align-items-center">
    //                   <span style={{marginRight: '8px'}}>{action.status ? '☑' : '☐'}</span>
    //                   <span className="typo-normal-150">{action.title}</span>
    //                 </div>
    //               ),
    //               height: 22,
    //             });
    //           });
    //         }
    //       });

    //       content.push({
    //         content: renderSpace(20),
    //         height: 20,
    //       });
    //     }

    //     // Add completed activities
    //     if (exportTasks || exportAppointments || exportAssessments) {
    //       content.push({
    //         content: renderH1("Completed Activities"),
    //         height: 36,
    //       });

    //       content.push({
    //         content: renderHR(),
    //         height: 2,
    //       });

    //       // Add tasks
    //       if (exportTasks) {
    //         let completedTasks = project.tasks.filter(task => task.statusType === 'COMPLETED');
    //         if (completedTasks.length > 0) {
    //           content.push({
    //             content: <div className="typo-strong-150">Tasks</div>,
    //             height: 28,
    //           });

    //           content.push({
    //             content: renderActivityRow("Task", "Completed By", "Completion Date"),
    //             height: 28,
    //           });

    //           completedTasks.forEach((task, index) => {
    //             content.push({
    //               content: renderActivityRow(task.title, task.closedByName, task.closedAt ? DateToFormat(DatetimeToDate(task.closedAt), context.dateFormat) : 'N/A'),
    //               height: 28,
    //             });
    //           });
    //         }
    //       }

    //       // Add appointments
    //       if (exportAppointments) {
    //         let completedAppointments = appointments.filter(appointment => appointment.statusType === 'COMPLETED' && appointment.closedAt > project.createdAt);
    //         if (completedAppointments.length > 0) {
    //           content.push({
    //             content: <div className="typo-strong-150">Appointments</div>,
    //             height: 28,
    //           });

    //           content.push({
    //             content: renderActivityRow("Appointment", "Completed By", "Completion Date"),
    //             height: 28,
    //           });

    //           completedAppointments.forEach((appointment, index) => {
    //             content.push({
    //               content: renderActivityRow(appointment.title, appointment.closedByName, appointment.closedAt ? DateToFormat(DatetimeToDate(appointment.closedAt), context.dateFormat) : 'N/A'),
    //               height: 28,
    //             });
    //           });
    //         }
    //       }

    //       // Add assessments
    //       if (exportAssessments) {
    //         let completedAssessments = assessments.filter(assessment => assessment.statusType === 'COMPLETED' && assessment.closedAt > project.createdAt);
    //         if (completedAssessments.length > 0) {
    //           content.push({
    //             content: <div className="typo-strong-150">Assessments</div>,
    //             height: 28,
    //           });

    //           content.push({
    //             content: renderActivityRow("Assessment", "Completed By", "Completion Date"),
    //             height: 28,
    //           });

    //           completedAssessments.forEach((assessment, index) => {
    //             content.push({
    //               content: renderActivityRow(assessment.title, assessment.closedByName, assessment.closedAt ? DateToFormat(DatetimeToDate(assessment.closedAt), context.dateFormat) : 'N/A'),
    //               height: 28,
    //             });
    //           });
    //         }
    //       }
    //     } 

    //     // Add clinical notes
    //     break;
    //   default:
    //     break;
    // }

    const limit = 900;
    let pages = [];
    let page = [];
    let pageHeight = 0;

    for (let i = 0; i < content.length; i++) {
      const item = content[i];
      const itemHeight = item.height;

      if (pageHeight + itemHeight > limit) {
        // If the current page is full, push it to pages
        pages.push(
          <div className="page" key={pages.length}>
            <div className="subpage">
              {page}
            </div>
          </div>
        );
        page = [];
        pageHeight = 0;
      }

      // Add the item to the current page
      page.push(item.content);
      pageHeight += itemHeight;
    }

    // If there is any remaining content in the current page, push it to pages
    if (page.length > 0) {
      pages.push(
        <div className="page" key={pages.length}>
          <div className="subpage">
            {page}
          </div>
        </div>
      );
    }

    return pages;
  }

  function renderCompanyHeader() {
    let content = [];
    
    content.push({
      content: <img src={"/api/admin/settings/logo?token="+context.token} style={{height: 50}} />,
      height: 50,
    });

    content.push({
      content: <div className="typo-strong-300">{settings.title}</div>,
      height: 36,
    });

    content.push({
      content: <div className="typo-normal-150">{settings.description}</div>,
      height: 20,
    });

    // Mergin break
    content.push({
      content: renderSpace(30),
      height: 30,
    });

    return content;
  }

  function renderPatient() {
    let content = [];

    // Patient name
    content.push({
      content: renderH1(patient.firstName + " " + patient.lastName),
      height: 36,
    });

    // Divider
    content.push({
      content: renderSpace(5),
      height: 5,
    });
    
    content.push({
      content: renderHR(),
      height: 2,
    });

    content.push({
      content: renderSpace(5),
      height: 5,
    });

    // Patient DOB, Medical Record Number (MRN) and gender
    content.push({
      content: <div className="d-flex justify-content-start align-items-top">
        <div className="w-50">
          <div className="typo-strong-150">Medical Record Number (MRN):</div>
          <div className="typo-normal-175">{getPatientFieldValue("medicalRecordNumber") || "n/a"}</div>
        </div>
        <div className="w-25">
          <div className="typo-strong-150">Date of Birth:</div>
          <div className="typo-normal-175">{getPatientFieldValue("dateOfBirth") ? DateToFormat(DatetimeToDate(getPatientFieldValue("dateOfBirth")), context.dateFormat) : "n/a"}</div>
        </div>
        <div className="w-25">
          <div className="typo-strong-150">Gender:</div>
          <div className="typo-normal-175">{getPatientFieldValue("gender") || "n/a"}</div>
        </div>
      </div>,
      height: 44,
    });

    // Mergin break
    content.push({
      content: renderSpace(30),
      height: 30,
    });

    return content;
  }

  function renderPlan(plan) {
    let content = [];

    // Title
    content.push({
      content: renderH1(plan.templateName),
      height: 36,
    });

    // Divider
    content.push({
      content: renderSpace(7),
      height: 7,
    });
    
    content.push({
      content: renderHR(),
      height: 2,
    });

    content.push({
      content: renderSpace(7),
      height: 7,
    });

    // Sections
    plan.sections.forEach((section) => {

      // Section title
      content.push({
        content: <div className="typo-strong-300">{section.title}</div>,
        height: 28,
      });

      // Break
      content.push({
        content: renderSpace(5),
        height: 5,
      });

      // Section description
      if (section.description) {
        content.push(calculateHeight(
          <div className="typo-normal-175" dangerouslySetInnerHTML={{__html: section.description}} />
        ));

        // Break
        content.push({
          content: renderSpace(10),
          height: 10,
        });
      }

      // Section actions
      section.actions.forEach((action) => {
        content.push(calculateHeight(
          <div className="d-flex justify-content-start align-items-top">
            <div style={{height: "24px", minWidth: "24px"}} className="d-flex justify-content-center align-items-center">
              {action.status ? <CheckLarge height={16} width={16} color={'green'} /> : <Minus height={16} width={16} color={'grey'} />}
            </div>
            <div className="typo-normal-175">{action.title}</div>
          </div>
        ));

        // Break
        content.push({
          content: renderSpace(5),
          height: 5,
        });
      });

      // Break
      content.push({
        content: renderSpace(10),
        height: 10,
      });
    });

    // Mergin break
    content.push({
      content: renderSpace(30),
      height: 30,
    });

    return content;
  }

  function renderProject(project) {
    let content = [];

    content.push({
      content: renderH1(patient.firstName + " " + patient.lastName),
      height: 36,
    });

    // Mergin break
    content.push({
      content: renderSpace(30),
      height: 30,
    });

    return content;
  }

  function renderAssessment(assessment) {
    let content = [];

    content.push({
      content: renderH1(patient.firstName + " " + patient.lastName),
      height: 36,
    });

    // Mergin break
    content.push({
      content: renderSpace(30),
      height: 30,
    });

    return content;
  }

  // Render helpers
  function renderH1(text) {
    return (
      <div className="typo-strong-300">{text}</div>
    );
  }

  function renderH2(text) {
    return (
      <div className="typo-strong-150">{text}</div>
    );
  }

  function renderHR() {
    return (
      <hr />
    );
  }

  function renderActivityRow(col1, col2, col3) {
    return (
      <div style={{display: "flex", justifyContent: "space-between"}}>
        <div style={{width: "50%"}}>
          <div className="typo-normal-150">{col1}</div>
        </div>
        <div style={{width: "25%"}}>
          <div className="typo-normal-150">{col2}</div>
        </div>
        <div style={{width: "25%"}}>
          <div className="typo-normal-150">{col3}</div>
        </div>
      </div>
    );
  }

  function renderSpace(height) {
    return (
      <div style={{height: height}}></div>
    );
  }

  function calculateHeight(content) {
    let height = 0;
    let width = 0;
  
    const page = document.createElement("div");
    page.className = "page";

    const subpage = document.createElement("div");
    subpage.className = "subpage";
    
    // Reset height to auto to get actual content height
    subpage.style.height = "auto";

    // Convert React element to HTML string if it's a React element
    if (typeof content === 'object' && content.type) {
      subpage.innerHTML = renderToStaticMarkup(content);
    } else {
      subpage.innerHTML = content;
    }
    
    page.appendChild(subpage);

    document.body.appendChild(page);
    height = subpage.offsetHeight;
    width = subpage.offsetWidth;
    document.body.removeChild(page);

    console.log("calculateHeight");
    console.log(content);
    console.log(height);
    console.log(width);

    return {
      content: content,
      height: height,
    };
  }

  // Helper
  function getPatientFieldValue(code) {
    if (!patient || !patient.fields) {
      return null;
    }
    
    const field = patient.fields.find(field => field.code === code);
    if (!field || !field.answers || field.answers.length === 0) {
      return null;
    }
    
    return field.answers[0];
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet title="Export" />

      <div className="container">
        <div className="row">
          <div className="col-xs-3 book-menu">

            {/* Patient */}
            <div className="card mb-3">
              <div className="card-header sm">
                <div className="typo-strong-200">Patient</div>
              </div>
            </div>

            {/* Plans */}
            <div className="card mb-3">
              <div className="card-header sm">
                <div className="typo-strong-200">Care plans</div>
              </div>
              {plans.length === 0 ? (
                <div className="card-header sm">
                  <div className="typo-normal-150">No care plans found</div>
                </div>
              ) : plans.map((plan) => (
                <div key={plan.id} className="card-header clickable sm" onClick={() => selectPlan(plan.id)}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="typo-strong-150">{plan.templateName}</div>
                    <div>{exportPlans.includes(plan.id) ? <CheckLarge height={16} width={16} color={'green'} /> : <Minus height={16} width={16} color={'grey'} />}</div>
                  </div>

                  <div className="typo-normal-150">{!plan.closedAt ? "Active" : "Closed"}</div>

                  <div className="typo-normal-150">
                    {DateToFormat(DatetimeToDate(plan.createdAt), context.dateFormat)}
                    {plan.closedAt && (
                      " - " +
                      DateToFormat(DatetimeToDate(plan.closedAt), context.dateFormat)
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Project */}
            {/* <div className="card mb-3">
              <div className="card-header sm">
                <div className="typo-strong-200">Projects</div>
              </div>
              {projects.map((project) => (
                <div key={project.id} className="card-header clickable sm" onClick={() => selectProject(project.id)}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="typo-strong-150">{project.templateName}</div>
                    <div>{exportProjects.includes(project.id) ? <CheckLarge height={16} width={16} color={'green'} /> : <Minus height={16} width={16} color={'grey'} />}</div>
                  </div>
                  <div className="typo-normal-150">{DateToFormat(DatetimeToDate(project.createdAt), context.dateFormat)}</div>
                </div>
              ))}
            </div> */}

            {/* Appointment */}
            {/* <div className="card mb-3">
              <div className="card-header sm">
                <div className="typo-strong-200">Appointments</div>
              </div>
              {appointments.map((appointment) => (
                <div key={appointment.id} className="card-header clickable sm">
                  <div className="typo-normal-150">{appointment.templateName}</div>
                </div>
              ))}
            </div> */}

            {/* Assessment */}
            {/* <div className="card mb-3">
              <div className="card-header sm">
                <div className="typo-strong-200">Assessments</div>
              </div>
              {assessments.map((assessment) => (
                <div key={assessment.id} className="card-header clickable sm" onClick={() => selectAssessment(assessment.id)}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="typo-strong-150">{assessment.templateName}</div>
                    <div>{exportAssessments.includes(assessment.id) ? <CheckLarge height={16} width={16} color={'green'} /> : <Minus height={16} width={16} color={'grey'} />}</div>
                  </div>
                  <div className="typo-normal-150">{DateToFormat(DatetimeToDate(assessment.createdAt), context.dateFormat)}</div>
                </div>
              ))}
            </div> */}

            <div className="card">
              <div className="card-content sm text-end">
                <div className="item grey typo-normal-150" onClick={() => window.print()}><Print height={16} width={16} color={'grey'} /> Print</div>
              </div>
            </div>
          </div>
          <div className="col-xs-9 book">
            {renderPages()}
          </div>
        </div>
      </div>
    </>
  );
}

export default Export;
